import { render, staticRenderFns } from "./CusTabbar.vue?vue&type=template&id=36ea526b&scoped=true&"
import script from "./CusTabbar.vue?vue&type=script&lang=js&"
export * from "./CusTabbar.vue?vue&type=script&lang=js&"
import style0 from "./CusTabbar.vue?vue&type=style&index=0&id=36ea526b&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea526b",
  null
  
)

export default component.exports